module.exports = __webpack_public_path__ + "img/slogo.f015e016.png";